import {ROUTE_NAMES} from "../../core/consts";
import {BaseConfig} from "../../infrastructure/config/base-config";
import {GameCenterRouteConfig} from "./models/game-center-route.config";

export class GameCenterContainerConfig extends BaseConfig {
  static injectables = [GameCenterRouteConfig];

  constructor(route: GameCenterRouteConfig) {
    super(ROUTE_NAMES.gameCenterPage, route);
  }
}